import { useFloating, inner, useInnerOffset, useInteractions } from "../../../../@floating-ui/react/dist/floating-ui.react.js";
import * as React from "react";
import { createContext, useMemo, useContext, useCallback, useState, useRef } from "react";
import { useDisposables as p } from "../hooks/use-disposables.js";
import { useEvent as o } from "../hooks/use-event.js";
import { useIsoMorphicEffect as n } from "../hooks/use-iso-morphic-effect.js";
import { offset, shift, flip, size } from "../../../../@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate } from "../../../../@floating-ui/dom/dist/floating-ui.dom.js";
let y = createContext({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
y.displayName = "FloatingContext";
let S = createContext(null);
S.displayName = "PlacementContext";
function xe(e) {
  return useMemo(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function ye() {
  return useContext(y).setReference;
}
function Fe() {
  return useContext(y).getReferenceProps;
}
function be() {
  let { getFloatingProps: e, slot: t } = useContext(y);
  return useCallback((...n2) => Object.assign({}, e(...n2), { "data-anchor": t.anchor }), [e, t]);
}
function Re(e = null) {
  e === false && (e = null), typeof e == "string" && (e = { to: e });
  let t = useContext(S), n$1 = useMemo(() => e, [JSON.stringify(e, typeof HTMLElement != "undefined" ? (r, o2) => o2 instanceof HTMLElement ? o2.outerHTML : o2 : void 0)]);
  n(() => {
    t == null || t(n$1 != null ? n$1 : null);
  }, [t, n$1]);
  let l = useContext(y);
  return useMemo(() => [l.setFloating, e ? l.styles : {}], [l.setFloating, e, l.styles]);
}
let q = 4;
function ve({ children: e, enabled: t = true }) {
  let [n$1, l] = useState(null), [r, o$1] = useState(0), c = useRef(null), [u, s] = useState(null);
  pe(u);
  let i = t && n$1 !== null && u !== null, { to: F = "bottom", gap: C = 0, offset: M = 0, padding: p2 = 0, inner: P } = ce(n$1, u), [a, f = "center"] = F.split(" ");
  n(() => {
    i && o$1(0);
  }, [i]);
  let { refs: b, floatingStyles: w, context: g } = useFloating({ open: i, placement: a === "selection" ? f === "center" ? "bottom" : `bottom-${f}` : f === "center" ? `${a}` : `${a}-${f}`, strategy: "absolute", transform: false, middleware: [offset({ mainAxis: a === "selection" ? 0 : C, crossAxis: M }), shift({ padding: p2 }), a !== "selection" && flip({ padding: p2 }), a === "selection" && P ? inner({ ...P, padding: p2, overflowRef: c, offset: r, minItemsVisible: q, referenceOverflowThreshold: p2, onFallbackChange(h) {
    var O, W;
    if (!h) return;
    let d = g.elements.floating;
    if (!d) return;
    let T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, $ = Math.min(q, d.childElementCount), B = 0, N = 0;
    for (let m of (W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : []) if (m instanceof HTMLElement) {
      let x = m.offsetTop, k = x + m.clientHeight + T, H = d.scrollTop, U = H + d.clientHeight;
      if (x >= H && k <= U) $--;
      else {
        N = Math.max(0, Math.min(k, U) - Math.max(x, H)), B = m.clientHeight;
        break;
      }
    }
    $ >= 1 && o$1((m) => {
      let x = B * $ - N + T;
      return m >= x ? m : x;
    });
  } }) : null, size({ padding: p2, apply({ availableWidth: h, availableHeight: d, elements: T }) {
    Object.assign(T.floating.style, { overflow: "auto", maxWidth: `${h}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)` });
  } })].filter(Boolean), whileElementsMounted: autoUpdate }), [I = a, V = f] = g.placement.split("-");
  a === "selection" && (I = "selection");
  let G = useMemo(() => ({ anchor: [I, V].filter(Boolean).join(" ") }), [I, V]), K = useInnerOffset(g, { overflowRef: c, onChange: o$1 }), { getReferenceProps: Q, getFloatingProps: X } = useInteractions([K]), Y = o((h) => {
    s(h), b.setFloating(h);
  });
  return React.createElement(S.Provider, { value: l }, React.createElement(y.Provider, { value: { setFloating: Y, setReference: b.setReference, styles: w, getReferenceProps: Q, getFloatingProps: X, slot: G } }, e));
}
function pe(e) {
  n(() => {
    if (!e) return;
    let t = new MutationObserver(() => {
      let n2 = window.getComputedStyle(e).maxHeight, l = parseFloat(n2);
      if (isNaN(l)) return;
      let r = parseInt(n2);
      isNaN(r) || l !== r && (e.style.maxHeight = `${Math.ceil(l)}px`);
    });
    return t.observe(e, { attributes: true, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function ce(e, t) {
  var o2, c, u;
  let n2 = L((o2 = e == null ? void 0 : e.gap) != null ? o2 : "var(--anchor-gap, 0)", t), l = L((c = e == null ? void 0 : e.offset) != null ? c : "var(--anchor-offset, 0)", t), r = L((u = e == null ? void 0 : e.padding) != null ? u : "var(--anchor-padding, 0)", t);
  return { ...e, gap: n2, offset: l, padding: r };
}
function L(e, t, n$1 = void 0) {
  let l = p(), r = o((s, i) => {
    if (s == null) return [n$1, null];
    if (typeof s == "number") return [s, null];
    if (typeof s == "string") {
      if (!i) return [n$1, null];
      let F = J(s, i);
      return [F, (C) => {
        let M = D(s);
        {
          let p2 = M.map((P) => window.getComputedStyle(i).getPropertyValue(P));
          l.requestAnimationFrame(function P() {
            l.nextFrame(P);
            let a = false;
            for (let [b, w] of M.entries()) {
              let g = window.getComputedStyle(i).getPropertyValue(w);
              if (p2[b] !== g) {
                p2[b] = g, a = true;
                break;
              }
            }
            if (!a) return;
            let f = J(s, i);
            F !== f && (C(f), F = f);
          });
        }
        return l.dispose;
      }];
    }
    return [n$1, null];
  }), o$1 = useMemo(() => r(e, t)[0], [e, t]), [c = o$1, u] = useState();
  return n(() => {
    let [s, i] = r(e, t);
    if (u(s), !!i) return i(u);
  }, [e, t]), c;
}
function D(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n2 = t[1].indexOf(",");
    if (n2 === -1) return [t[1]];
    let l = t[1].slice(0, n2).trim(), r = t[1].slice(n2 + 1).trim();
    return r ? [l, ...D(r)] : [l];
  }
  return [];
}
function J(e, t) {
  let n2 = document.createElement("div");
  t.appendChild(n2), n2.style.setProperty("margin-top", "0px", "important"), n2.style.setProperty("margin-top", e, "important");
  let l = parseFloat(window.getComputedStyle(n2).marginTop) || 0;
  return t.removeChild(n2), l;
}
export {
  ve as FloatingProvider,
  Re as useFloatingPanel,
  be as useFloatingPanelProps,
  ye as useFloatingReference,
  Fe as useFloatingReferenceProps,
  xe as useResolvedAnchor
};
